import request from '@/auth/jwt/request'

/**
 * @description 经纪人客户 -- 查询列表
 * id = 0 新增
 * @param {Object} param params {Object} 传值参数
 */
export const brokerCustomerListApi = params => { return request('broker-customer-project/list', 'get', params) }

/**
 * @description 经纪人客户 -- 释放
 * id = 0 新增
 * @param {Object} param params {Object} 传值参数
 */
export const brokerCustomerReleaseApi = params => { return request('broker-customer-project/release', 'get', params) }

/**
 * @description 经纪人客户 -- 更改保护期
 * id = 0 新增
 * @param {Object} param params {Object} 传值参数
 */
export const brokerCustomerUpdateDaysApi = params => { return request('broker-customer-project/updateDays', 'get', params) }

/**
 * @description 经纪人客户 -- 签约
 * id = 0 新增
 * @param {Object} param params {Object} 传值参数
 */
export const brokerCustomerSignApi = params => { return request('broker-customer-project/sign', 'get', params) }

/**
 * @description 经纪人客户 --- 项目下拉
 * @param {Object} param params {Object} 传值参数
 */
export const brokerCustomerProjectList = params => { return request('pull-down/projectSelect', 'get', params) }